import { TypedAction } from '@ngrx/store/src/models';
import { activateSubcategoryFiltersByValue } from './category.actions';
import { AppState, UrlPartSerializer } from '@immosky/types';

export class SubcategoryFilterSerializer implements UrlPartSerializer {
  constructor(public readonly key: string) {}

  deserialize(urlValue: string): TypedAction<string> {
    const values = urlValue.split(',').map((v) => v.trim());
    return activateSubcategoryFiltersByValue({
      values,
    });
  }

  serialize(state: AppState): string {
    const categoryValue = state.filter.category.main.filter.value;
    const subcategoryFilter = state.filter.category.sub.filter[categoryValue];

    return subcategoryFilter
      .filter((o) => o.isChecked)
      .map((o) => o.value)
      .join(',');
  }
}
